import { ca } from '@cian/analytics';

export const trackRatingClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingAgents',
    action: 'Click',
    label: 'raiting',
  });
};
